import type { Component } from '@wix/thunderbolt-becky-types'
import type { FeatureRefs } from '../cssFeatures.types'
import { createCssCompNode } from '../cssCompNode'
import type { CompData } from '@wix/thunderbolt-becky-root'
import { envRefs } from '@wix/thunderbolt-catharsis'
import type { MeshChild, MeshChildCompNode } from './mesh.types'
import { shouldRemoveChildFromStructure, shouldCalculateMesh } from './meshCompNodeHelpers'

export const meshChild = (isEditor: boolean) =>
	createCssCompNode('mesh', 'meshChild', {
		getDependencies: (component: Component, refs: FeatureRefs<'mesh'>) => {
			if (shouldRemoveChildFromStructure(component)) {
				return null
			}
			const deps =
				component.componentType === 'Column'
					? {
						compData: ({
							props: refs.propertyQuery(component.propertyQuery!),
							style: refs.styleId(component.styleId!),
							data: refs.dataQuery(component.dataQuery!),
						} as unknown) as CompData,
					}
					: {}
			return {
				...deps,
				autoHeightWrapper: isEditor ? refs.autoHeightWrapper?.(component) : false,
				meshChildren: (component.components || []).map(refs.meshChild),
				isMobileView: envRefs.isMobileView,
				hasResponsiveLayout: refs.hasResponsiveLayout(component),
			}
		},
		toViewItem: (component, deps) => {
			if (!deps || deps.hasResponsiveLayout) {
				return null
			}

			// Remove hidden & ghost children components
			const meshChildren = deps.meshChildren.filter((child: MeshChildCompNode) => !!child) as Array<MeshChild>
			const componentWithMeshChildrenOnly = {
				...component,
				components: meshChildren.map((child: MeshChild) => child.id),
			}

			const {
				isMobileView,
				autoHeightWrapper,
				compData,
				hasResponsiveLayout,
			} = deps

			return {
				id: component.id,
				component: componentWithMeshChildrenOnly,
				meshChildren,
				isMobileView,
				autoHeightWrapper,
				compData,
				shouldCalculateMesh: shouldCalculateMesh(component, hasResponsiveLayout),
			} as MeshChildCompNode
		},
	})
